export default __webpack_public_path__ + "static/media/large.3ea43486.jpg";